import '@mantine/core/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { restoreSessionFx } from '@buildex/core';
import { initI18n } from './app/i18n';
import { App } from './app/App';

initI18n();

// Админке конфиг тенанта не нужен — только восстановление сессии
void restoreSessionFx();

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('#root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
